import { getTranslatedString } from 'helpers/i18n';
import { incentiveStatus } from './IncentiveStatus';

const formatAssociationGroups = (associationGroups) =>
  associationGroups.map((associationGroup) => ({
    ...associationGroup,
    unit_ids: removeAppend(associationGroup.associations),
    associations: undefined,
  }));

export const formatPayload = (data) => ({
  ...data,
  benefits_attributes: data.benefits,
  association_groups_attributes: formatAssociationGroups(data.association_groups),
  incentive_codes_attributes: data.incentive_codes,
  association_groups: undefined,
  benefits: undefined,
  incentive_codes: undefined,
});

/**
 * Appends "unit__" to each id
 * @param {Array} unit_ids
 * @returns {Array}
 * @example
 * appendUnitIds([1, 2, 3]) // ["unit__1", "unit__2", "unit__3"]
 */
export const appendUnitIds = (unit_ids) => unit_ids.map((id) => `unit__${id}`);

/**
 * Removes append from string
 * @param {String} association
 * @returns {String}
 * @example
 * removeAppend("unit__1") // "1"
 * removeAppend("site__2") // "2"
 */
export const removeAppend = (associations) =>
  associations.map((association) => parseInt(association.split('__').slice(-1))).flat();

export const getSuccessfulMessage = (status) => {
  switch (status) {
    case incentiveStatus.draft:
      return getTranslatedString('landlordPortal.incentives.successDraftTitle');
    case incentiveStatus.published:
      return getTranslatedString('landlordPortal.incentives.successPublishedTitle');
    case incentiveStatus.archived:
      return getTranslatedString('landlordPortal.incentives.successArchivedTitle');
    default:
      return getTranslatedString('success');
  }
};
